class DialogQuickBuy extends HTMLElement {
  connectedCallback () {
    this.dialog = this.querySelector('[data-dialog-quick-buy-el="dialog"]')
    this.selectionWrappers = this.querySelectorAll('[data-dialog-quick-buy-el="selectionWrapper"]')
    this.selections = this.querySelectorAll('[data-dialog-quick-buy-el="selection"]')
    this.notifyMe = this.querySelector('[data-dialog-quick-buy-el="notifyMe"]')
    this.form = this.querySelector('[data-dialog-quick-buy-el="form"]')
    this.inner = this.querySelector('[data-dialog-quick-buy-el="inner"]')
    this.addToCartButton = this.querySelector('[data-dialog-quick-buy-el="atcButton"]')
    this.closeButton = this.querySelector('[data-dialog-quick-buy-el="close"]')

    this.cartItems = document.querySelector('cart-items')

    this.setEventListeners()
  }

  setEventListeners () {
    this.addEventListener('submit', this.onSubmit.bind(this))

    this.selections.forEach(selection => {
      selection.addEventListener('change', this.onSelectionChange.bind(this))
    })

    this.closeButton.addEventListener('click', this.close.bind(this))

    this.dialog.addEventListener('click', (event) => {
      if (!this.inner.contains(event.target)) {
        this.close()
      }
    })
  }

  onSelectionChange (event) {
    const selectionWrapper = event.currentTarget.closest('[data-dialog-quick-buy-el="selectionWrapper"]')
    const isAvailable = selectionWrapper.dataset.available === 'true'

    if (isAvailable) {
      this.addToCartButton.ariaHidden = false
      this.addToCartButton.disabled = false
      this.addToCartButton.textContent = 'Add to cart'

      this.notifyMe.ariaHidden = true
    } else {
      const rootProductUrl = this.notifyMe.href.split('?')
      const variantId = event.currentTarget.id

      this.notifyMe.href = `${rootProductUrl[0]}?variant=${variantId}`

      this.addToCartButton.ariaHidden = true
      this.notifyMe.ariaHidden = false
    }
  }

  onSubmit (event) {
    event.preventDefault()
    this.addToCartButton.disabled = true
    this.addToCartButton.textContent = 'Adding to cart...'

    const formData = new FormData(this.form)

    if (this.cartItems) {
      formData.append('sections', this.cartItems.getSectionsToRender().map((section) => section.id))
      formData.append('sections_url', window.location.pathname)
    }

    const body = new URLSearchParams(formData).toString()

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
    })
      .then(response => response.json())
      .then(json => {
        this.addToCartButton.textContent = 'Added to cart'
        this.close()
        this.cartItems?.renderContents(json)
        setTimeout(() => {
          this.addToCartButton.textContent = 'Add to cart'
          this.addToCartButton.disabled = true
        }, 2000)

        if (this.dataset.root === 'category') {
          window.theme.category.eventBus.publish('category:tracking:product:added', {
            type: 'category',
            productId: json.id,
            url: json.url,
          })
        }

        if (this.dataset.root === 'searchResults') {
          window.theme.searchResults.eventBus.publish('searchResults:tracking:product:added', {
            type: 'serp',
            productId: json.id,
            url: json.url,
          })
        }

        if (this.dataset.root === 'autocomplete') {
          window.theme.searchAutocomplete.eventBus.publish('autocomplete:tracking:product:added', {
            type: 'autocomplete',
            productId: json.id,
            url: json.url,
          })
        }
      })
      .catch(error => {
        console.error('Error:', error)
      })
  }

  close () {
    this.dialog.close()
    const event = new CustomEvent('quick-add:clear', { bubbles: true })
    this.dispatchEvent(event)
  }

  openCart () {
    document.querySelector('#cart-icon-bubble').click()
  }
}

customElements.define('dialog-quick-buy', DialogQuickBuy)
